export default __webpack_public_path__ + "static/media/aeroplane.ada4b591.svg";